// Konvensi multivalue — HARUS sama dengan backend (src/utils/multivalue.js):
//   students.sessions dipisah ", "  (mis. "16.00 - 17.30, 18.45 - 20.15")
//   students.trainer  dipisah " & "  (mis. "Ms. Afi & Ms. Deby")
// Satu murid bisa ikut beberapa sesi (multi-kelas) / satu kelas 2 pengajar.
export const SESSION_DELIM = ", ";
export const TRAINER_DELIM = " & ";

export function parseSessions(value) {
  return String(value || "")
    .split(",")
    .map((s) => s.trim())
    .filter(Boolean);
}

export function parseTrainers(value) {
  return String(value || "")
    .split(TRAINER_DELIM)
    .map((s) => s.trim())
    .filter(Boolean);
}

export const joinSessions = (arr) => arr.join(SESSION_DELIM);
export const joinTrainers = (arr) => arr.join(TRAINER_DELIM);
